export default __webpack_public_path__ + "static/media/facebook-box.ecc647f7.svg";